import React from "react";
import HelpModal from "common/HelpModal.jsx";

const SystemInformationStatusHelp = () => (
  <HelpModal
    title="System Information"
    content={() => (
      <ul>
        <li>
          <b>System name</b>: BQN server host name.{" "}
        </li>
        <li>
          <b>BQN release</b>: BQN software package release.{" "}
        </li>
        <li>
          <b>Vendor</b>: Hardware vendor.{" "}
        </li>
        <li>
          <b>Product</b>: Hardware product identifier.{" "}
        </li>
        <li>
          <b>Serial number</b>: Hardware serial number (n/a if unknown).{" "}
        </li>
        <li>
          <b>Hardware ID</b>: Internal hardware identifier.{" "}
        </li>
        <li>
          <b>CPU model</b>: CPU model.{" "}
        </li>
        <li>
          <b>CPU cores</b>: CPU number of cores.{" "}
        </li>
        <li>
          <b>Memory size</b>: Main memory size.{" "}
        </li>
        <li>
          <b>Root disk partition</b>: Root disk partition used and available
          memory size.{" "}
        </li>
        <li>
          <b>Dropped pkts</b>: Dropped packets since last start.{" "}
        </li>
      </ul>
    )}
  />
);

export default SystemInformationStatusHelp;
